import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-904f16a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FooterCopyright = _resolveComponent("FooterCopyright")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createVNode(_component_FooterCopyright)
  ]))
}